import router from '@/app/routes/router';
import store from '@/app/stores/store';

// set page title based on route meta title
export default function routeGuard() {
	router.beforeEach((to, from, next) => {
		// Don't delete incase they want the permission again for walker sitter
		// const userDetails = store.getters.getUserDetails;
		// const customerOnly = to.meta.customerOnly;

		const userToken = store.getters.getUserToken;
		const subscriptions = store.getters.getSubscriptions;
		const requiredAuth = to.meta.isAuthRequired;
		const globalRoute = to.meta.isGloballyAccessible;
		const referrerRoute = to.fullPath ? to.fullPath : '/';
		const nextRoute = to.name;
		const env = process.env.VUE_APP_NODE_ENV;
		let metaTitle = '';

		if (globalRoute) {
			if (nextRoute === 'Style Guide' && env !== 'local') {
				next({name: 'ErrorView'});
			} else {
				next(true);
			}
			metaTitle = to.meta.title;
			document.title = metaTitle;
		} else {
			// Check if destination route required Authentication
			if (requiredAuth) {
				// Check if Token exists
				if (userToken) {
					metaTitle = to.meta.title;

					// Don't delete incase they want the permission again for walker sitter
					// Check if page is for CUST Role only
					// if (customerOnly && userDetails.userRole !== 'CUST') {
					// 	next({name: 'ErrorView'});
					// }
					
					switch (nextRoute) {
						case 'Health Data':
							if (from.name) {
								metaTitle = from.meta.title;

								store.dispatch('showComingSoon');
								next(false);
							} else {
								metaTitle = 'Love My Dog Club - Page Not Found';

								next({name: 'ErrorView'});
							}
							break;

						case 'Tracking':
							// check if user has tracking subscription
							const tracking = subscriptions.tracking;

							if (!tracking || !tracking.isTrackingDeviceConnected || tracking.expiredSubscription || !tracking.subscriptionStatus || tracking.subscriptionStatus === 'I' || tracking.subscriptionStatus === 'C') {
								store.dispatch('showComingSoon');
								// prevent to navigate to tracking page and allow only when coming to login page
								if (from.name && from.name !== 'Auth Login') {
									next(false);
								} else {
									metaTitle = 'Love My Dog Club - Dashboard';
									next({name: 'Dashboard'});
								}
							} else {
								next(true);
							}
							break;

						default:
							next(true);
					}
				} else {
					// Redirect to Login if token Doesn't exist
					metaTitle = 'Love My Dog Club - Login';
					next({name: 'Auth Login', query: { from: referrerRoute }});
				}
			} else {
				// proceed if Route has Auth Service related JWT and is Set or Reset Password component.
				if ((to.query.AUTHSERVICE_JWT || to.query.AUTHSERVICE_EMAIL_TOKEN) && (to.name === 'Auth Set Password' || to.name === 'Auth Reset Password')) {
					// logout currently logged in user.
					if (userToken) {
						store.commit('clearLmdcUserDetails');
						store.commit('clearUserToken');
						store.commit('resetActiveGroup');
					}

					metaTitle = to.meta.title;
					next(true);
				} else {
					// If user is logged in, redirect back to authenticated pages. Prevents going back to Login and Registration.
					if (userToken) {
						metaTitle = 'Love My Dog Club - Dashboard';
						next({name: 'Dashboard'});
					} else {
						metaTitle = to.meta.title;
						next(true);
					}
				}
			}
			// Set tab title
			document.title = metaTitle;
		}
		// Reset active social group if needed.
		if ((from.path === '/social' || from.path === '/social/group' || from.path === '/post') && !(to.path === '/social' || to.path === '/social/group' || to.path === '/post')) {
			setTimeout(() => {
				store.commit('resetActiveGroup');
			}, 500);
		}
	});
}